// Color Palette
// Pantone color values for consistent branding across the application

// Helper function to convert hex to rgba
const hexToRgba = (hex, alpha = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const colors = {
  // Primary Colors
  darkGray: '#37424A',      // PANTONE 432 C
  black: '#000000',          // BLACK
  
  // Secondary Colors
  blueGray: '#44697D',       // PANTONE 5405 C
  greenGray: '#627D77',      // PANTONE 5487 C
  darkGreen: '#23423A',      // PANTONE 560 C
  
  // Accent Colors
  lightPurpleGray: '#A5A2C6', // PANTONE 7445 C
  lightPeach: '#EFBE9C',      // PANTONE 473 C
  mediumBrown: '#BD9271',     // PANTONE 4655 C
  
  // Tertiary Colors
  mutedPurple: '#89687C',     // PANTONE 5205 C
  darkMutedPurple: '#644459', // PANTONE 5195 C
  warmGray: '#675C53',        // PANTONE WARM GRAY 11 C
  
  // Helper function for rgba values
  rgba: hexToRgba,
};

// Pantone names for reference
export const pantoneNames = {
  darkGray: 'PANTONE 432 C',
  black: 'BLACK',
  blueGray: 'PANTONE 5405 C',
  greenGray: 'PANTONE 5487 C',
  darkGreen: 'PANTONE 560 C',
  lightPurpleGray: 'PANTONE 7445 C',
  lightPeach: 'PANTONE 473 C',
  mediumBrown: 'PANTONE 4655 C',
  mutedPurple: 'PANTONE 5205 C',
  darkMutedPurple: 'PANTONE 5195 C',
  warmGray: 'PANTONE WARM GRAY 11 C',
};

export default colors;

